import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

export const AdminCrmRoutes: RouteRecordRaw[] = [
    {
        path: '',
        redirect: '/admin/crm/settings'
    },
    {
        path: 'settings',
        component: wrapRuntimeImport(() => import('./screens/settings.vue')),
        meta: { admin: true }
    },
    {
        path: 'file-categories',
        component: wrapRuntimeImport(() => import('./screens/file-categories.vue')),
        meta: { admin: true }
    }
];
